/* unplugin-vue-components disabled */import script from "./AdaptiveBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdaptiveBox.vue?vue&type=script&lang=ts&setup=true"

import "./AdaptiveBox.vue?vue&type=style&index=0&id=8dee2824&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ZhongGuan\\Project\\zhong-guan-lh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dee2824"]])

export default __exports__